export const load = () => ({
	title: 'Window Inserts for Odd-Shaped Windows',
	showTitle: true,
});
